export const placeQueryData = {
  page: 1,
  limit: 20,
  isActive: true,
};
